import React from 'react';
import { WalletConnect } from '../Auth/WalletConnect';

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Overlay cosmique avec animation */}
      <div 
        className="absolute inset-0 bg-gradient-to-br from-emerald-900/95 via-gray-900/95 to-cyan-900/95 backdrop-blur-lg"
        onClick={onClose}
      />
      
      {/* Modal content */}
      <div className="relative z-10 w-full max-w-md mx-4 cosmic-card p-8 transform transition-all duration-500 animate-fade-in">
        {/* Effet de particules flottantes */}
        <div className="absolute inset-0 overflow-hidden rounded-2xl pointer-events-none">
          {[...Array(20)].map((_, i) => (
            <div
              key={i}
              className="absolute w-1 h-1 bg-cyan-400/60 rounded-full animate-float pointer-events-none"
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 3}s`,
                animationDuration: `${3 + Math.random() * 2}s`
              }}
            />
          ))}
        </div>

        {/* Header avec fermeture */}
        <div className="flex justify-between items-start mb-6">
          <div className="flex-1">
            <div className="text-center mb-4">
              <div className="text-6xl mb-4 animate-bounce">🚀</div>
              <h2 className="text-2xl lg:text-3xl font-bold text-emerald-100 mb-2 neon-text">
                Bienvenue chez les Jupipotes !
              </h2>
              <p className="text-emerald-200/80 text-sm lg:text-base">
                La communauté francophone #1 pour Jupiter & Solana
              </p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="text-emerald-300/60 hover:text-emerald-100 transition-colors p-1"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Contenu principal */}
        <div className="space-y-6 relative z-10">
          {/* Features highlights */}
          <div className="space-y-3">
            <div className="flex items-center space-x-3 text-emerald-200">
              <span className="text-cyan-400">✨</span>
              <span className="text-sm">Découvrez les derniers news Jup FR</span>
            </div>
            <div className="flex items-center space-x-3 text-emerald-200">
              <span className="text-cyan-400">🎯</span>
              <span className="text-sm">Partagez vos idées et créations</span>
            </div>
            <div className="flex items-center space-x-3 text-emerald-200">
              <span className="text-cyan-400">🌟</span>
              <span className="text-sm">Gagnez des XP et débloquez des badges</span>
            </div>
            <div className="flex items-center space-x-3 text-emerald-200">
              <span className="text-cyan-400">🚀</span>
              <span className="text-sm">Explorez l'écosystème Jup ensemble</span>
            </div>
          </div>

          {/* Wallet connection */}
          <div className="border-t border-emerald-800/50 pt-6 relative z-20">
            <p className="text-center text-emerald-300 mb-4 text-sm">
              Connectez votre wallet pour rejoindre l'aventure JUP FR !
            </p>
            <WalletConnect />
          </div>

          {/* Footer */}
          <div className="text-center pt-4 border-t border-emerald-800/50">
            <p className="text-xs text-emerald-300/60">
              En vous connectant, vous acceptez de faire partie de l'équipage des Jupipotes 🐱‍🚀
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
